export default __webpack_public_path__ + "static/media/view-map.35ed5041.png";